import React, { useEffect, useState } from "react";
import "./HeaderClientAdmin.css";
import Logo from "../../assets/logo.svg";
import Logotext from "../../assets/logoText.svg";
import Search from "../../assets/icons/Search-dashboard.svg";
import Profile from "../../assets/icons/user-profile.svg";
import DropDownIcon from "../../assets/icons/chevron-down.svg";
import DropUpIcon from "../../assets/icons/chevron-down.svg";
import signout from "../../assets/icons/sign-out.svg";
import Invite from "../../assets/icons/Share.svg";
import { Avatar, Input, Popover } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../service/store";
import { setProfileImage, setProfileName, setWorkBenchName, setSearchText, setInviteUserModal, setDashboardModalsOpens, setIsAdmin, setActiveCard } from "../../service/apiSlices/staticApi";
import { clearSessionStorage } from "../../utilities/helper";
import useDebounce from "../../hooks/useDebounce";
import { useDashboardSearchModelQuery, useGetAdminProfileQuery } from "../../service/apiSlices/dashboard";
import EditProfileModal from "../EditProfileModal/EditProfileModal";
import SearchResultsList from "./SearchResultList";
import { ROUTES, TOKENS } from "../../utilities/Constants/Constants";
import { allowOnlyAlphaNumericAndSpaces, handleWorkbenchNameInput } from "../../utilities/utils";
import { useTranslation } from "react-i18next";
import { showErrorToast } from "../../utilities/toastUtils";
import InviteTeamModal from "../InviteTeam/InviteTeamModal";
import { usePermission } from "../../hooks/usePermission";
// import { useNavigationAvailability } from "../../hooks/useNavigationAvailability";

const defaultConfig = {
    showSearch: false,
    showModalTitle: false,
    showInviteTeam: false,
}

const HeaderClientAdmin = ({ pageTitle, config }: { pageTitle?: string, config?: any }) => {
    const updatedConfig = { ...defaultConfig, ...config }
    const { t } = useTranslation('common');
    // const {canGoBack, canGoForward, back, forward} = useNavigationAvailability()

    const [editable, setEditable] = useState(false);
    const [searchTextHeader, setSearchTextHeader] = useState<string>("")
    const [searchActive, setSearchActive] = useState(false)
    const [accProfileName, setAccProfileName] = useState("")
    const [accProfileDesignation, setAccProfileDesignation] = useState("")
    const [accProfileImage, setaccProfileImage] = useState("")
    const [open, setOpen] = useState(false);
    const workBenchName = useSelector((state: RootState) => state?.static?.workBenchName);
    const isInviteModalOpen = useSelector((state: RootState) => state?.static.inviteUserModal);
    const isAdmin = useSelector((state: RootState) => state?.static?.isAdmin);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const debouncedSearchValue = useDebounce(searchTextHeader);
    const [isEditModelOpen, setIsEditModelOpen] = useState<boolean>(false);
    const token = sessionStorage.getItem(TOKENS.ACCESS_TOKEN);
    const [adminProfileData, setAdminProfileData] = useState<any>("");
    const [searchResultsVisible, setSearchResultsVisible] = useState(false);

    let searchPayload = {
        search: debouncedSearchValue,
        format_type: ""
    }
    const { data: searchModelList } = useDashboardSearchModelQuery(searchPayload, { skip: !searchActive });
    const { data: adminData, refetch: refetchAdminProfile } = useGetAdminProfileQuery("");
    const { canEdit, canView } = usePermission();

    useEffect(() => {
        if (adminData?.data?.firstname) {
            const fullName = `${adminData?.data?.firstname} ${adminData?.data?.lastname}`.trim();
            const profileImageURL = adminData?.data?.profile_image;
            setAccProfileName(fullName);
            setAccProfileDesignation(adminData?.data?.designation);
            dispatch(setProfileName(fullName));
            dispatch(setProfileImage(profileImageURL));
            setaccProfileImage(profileImageURL);
            setAdminProfileData(adminData.data);
            dispatch(setIsAdmin(adminData?.data?.is_admin));
        }
    }, [adminData, dispatch]);

    useEffect(() => {
        if (token && adminData && (
            adminData?.data?.firstname === "" ||
            adminData?.data?.firstname === null ||
            adminData?.data?.firstname === undefined
        )) {
            setIsEditModelOpen(true);
        }
    }, [adminData, token]);

    const handleModalClose = async () => {
        setIsEditModelOpen(false);
        await new Promise(resolve => setTimeout(resolve, 0));
        await refetchAdminProfile();
    };

    const onLogOut = () => {
        clearSessionStorage();
        navigate(ROUTES.LOGIN);
    };

    const handleRenameWorkbench = () => {
        if (canEdit && canView) {
            setEditable(true); // Enable editing
        }
    };

    const getRenameValue = (event: React.FocusEvent<HTMLInputElement>) => {
        const newName = event?.target?.value?.trim() || '';
        if (newName.length < 3) {
            showErrorToast("Workbench name must be at least 3 characters long.");
            dispatch(setWorkBenchName(""));
            setEditable(false);
            return;
        } else {
            dispatch(setWorkBenchName(newName));
            setEditable(false);
        }
    };

    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const searchValue = event.target.value;
        setSearchActive(true);
        setSearchTextHeader(searchValue);
        dispatch(setSearchText(searchValue)); // Dispatch action to store search text
        setSearchResultsVisible(searchValue.trim().length > 0);
    };

    const handleSearchItemSelect = (item: any) => {
        setSearchResultsVisible(false);
    };

    const editProfile = () => {
        setOpen(false);
        setIsEditModelOpen(true);
    };

    const handleOpenChange = (newOpen: boolean) => {
        setOpen(newOpen);
    };

    const handleInviteUser = () => {
        dispatch(setInviteUserModal(true));
        dispatch(setDashboardModalsOpens(true));
        setOpen(false);
    };

    const content = (
        <>
            <p onClick={editProfile} className="user-actions-item"><img src={Profile} alt="edit-profile" />{t('profile.editProfile')}</p>
            <div className="divider"></div>
            {updatedConfig.showInviteTeam && isAdmin &&
                <>
                    <p onClick={handleInviteUser} className="user-actions-item"><img src={Invite} alt="signout" />{t("profile.inviteTeam")}</p>
                    <div className="divider"></div>
                </>
            }
            <p onClick={onLogOut} className="user-actions-item"><img src={signout} alt="signout" />{t("profile.signOut")}</p>
        </>
    );

    function handleEdit(): void {
        throw new Error("Function not implemented.");
    }

    const handleNaviagteHome = () => {
        sessionStorage.removeItem("activeCard")
        dispatch(setActiveCard(""))
        navigate('/dashboard')
    }

    return (
        <div className={isEditModelOpen || isInviteModalOpen ? "header show" : "header"}>
            <div className="row">
                <div className="col-md-12 d-flex ">
                    <div className="card header-content-card w-100">
                        <div className="card-body">
                            <div className="d-flex gap-2 align-items-center justify-content-between">
                                <div className='d-flex align-items-center gap-4'>
                                    <div className="d-flex gap-2 align-items-center" onClick={handleNaviagteHome}>
                                        <img src={Logo} alt='logo' className="main-logo" width={30} />
                                        <img src={Logotext} alt='Logotext' className="logo-text" width={40} />
                                    </div>

                                    <div className="d-flex align-items-center gap-2">
                                        {/* <Button disabled={!canGoBack} className="nav-button-wrapper" size='small' icon={<img src={BackIcon} alt="" className="nav-icon-wrapper"/>} onClick={back}/>
                                        <Button disabled={!canGoForward} className="nav-button-wrapper" size='small' icon={<img src={ForwardIcon} alt="" className="nav-icon-wrapper"/>} onClick={forward}/> */}
                                        <h6 className="mb-0 page-title">{pageTitle}</h6>
                                    </div>
                                </div>
                                {updatedConfig.showSearch && (
                                    <>
                                        <div className="search-input-container">
                                            {/* <Input
                                                className="search-input"
                                                onChange={handleSearch}
                                                placeholder={t('header-search-placeholder')}
                                                prefix={<img src={Search} alt="search" width={18} />}
                                                onFocus={() => setSearchResultsVisible(searchTextHeader.trim().length > 0)}
                                                onBlur={() => setTimeout(() => setSearchResultsVisible(false), 200)}
                                            /> */}
                                            {searchResultsVisible && (
                                                <SearchResultsList
                                                    searchModelList={searchModelList?.data}
                                                    onItemSelect={handleSearchItemSelect}
                                                />
                                            )}
                                        </div>
                                    </>
                                )}
                                {updatedConfig.showModalTitle && (
                                    <div className="d-flex align-items-center gap-3">
                                        <p className="mb-0 workbench-title" style={editable ? { width: "auto" } : { width: "auto" }}>{t('workbenchName')} :</p>
                                        {editable ? (
                                            <div className="inputWrapper">
                                                <Input
                                                    type="text"
                                                    className="name-input"
                                                    maxLength={100}
                                                    onBlur={getRenameValue}
                                                    defaultValue={workBenchName}
                                                    placeholder={t('workbenchNamePlaceholder')}
                                                    autoFocus
                                                    onKeyPress={allowOnlyAlphaNumericAndSpaces}
                                                    onInput={handleWorkbenchNameInput}
                                                />
                                            </div>
                                        ) : (
                                            <p onClick={handleRenameWorkbench} className="sub-title mb-0">
                                                {workBenchName || `Click to enter new workbench name`}
                                            </p>
                                        )}
                                    </div>
                                )}
                                <div className="user-profile">
                                    {accProfileImage === "" ? <Avatar>{`${adminData?.data?.firstname?.charAt(0)}${adminData?.data?.lastname?.charAt(0)}`}</Avatar> : <Avatar src={accProfileImage} size={"default"} />}
                                    <div className="">
                                        <p className="user-name">{accProfileName ? accProfileName : "New User"}</p>
                                        <p className="mb-0 designation">{accProfileDesignation ? accProfileDesignation : "user"}</p>
                                    </div>
                                    <Popover
                                        content={content}
                                        trigger="click"
                                        open={open}
                                        onOpenChange={handleOpenChange}
                                        placement="bottomLeft"
                                        overlayClassName="headerUserActions"
                                        arrow={false}
                                    >
                                        <button className="btn p-0" type='button' onClick={(e) => e.preventDefault()}>
                                            <img src={open ? DropUpIcon : DropDownIcon} alt="down-arrow" className={open ? "dropDownOpen" : "dropDownClose"} />
                                        </button>
                                    </Popover>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <EditProfileModal
                visible={isEditModelOpen}
                onConfirm={handleEdit}
                onCancel={handleModalClose}
                title={""}
                content={""}
                okText={"Confirm"}
                cancelText={"Cancel"}
                userProfileData={adminProfileData}
            />

            <InviteTeamModal
                visible={isInviteModalOpen}
                onClose={() => { dispatch(setInviteUserModal(false)); dispatch(setDashboardModalsOpens(false)); }}
            />

        </div>
    )
};

export default HeaderClientAdmin;